import styles from "../campain.module.css";
import { useState } from "react";
import { MdAddCircleOutline } from "react-icons/md";
import { MdOutlineKeyboardArrowDown } from "react-icons/md";
import DatePicker, { DateObject } from "react-multi-date-picker";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";

const InsertAcordion = ({ index }) => {
  const toggleAccordion = () => {
    const el = document.querySelector(`#accordion5-${index}`);
    if (el.classList.contains("show")) {
      el.classList.replace("show", "collapsed");
    } else {
      el.classList.add("show");
    }
  };
  const [inputFields, setInputFields] = useState([{ nameField: "", name: "" }]);
  const allStep = [
    "اول",
    "دوم",
    "سوم",
    "چهارم",
    "پنجم",
    "ششم",
    "هفتم",
    "هشتم",
    "نهم",
    "دهم",
  ];
  const handleChangeInput = (index, event) => {
    const values = [...inputFields];
    values[index][event.target.name] = event.target.value;
    setInputFields(values);
  };
  const handleAddFields = () => {
    setInputFields([...inputFields, { nameField: "", name: "" }]);
  };
  return (
    <div className="clue">
      <p className="px-3 pt-2 ">
        <button
          className={`  ${styles.btnacardeon3}`}
          type="button"
          onClick={toggleAccordion}
        >
          <MdOutlineKeyboardArrowDown />
        </button>
      </p>
      <div className="collapse" id={`accordion5-${index}`}>
        <div className="px-1 pb-2">
          <div className={styles.stepsContainer}>
            <div className={`d-flex justify-content-between  ${styles.steps}`}>
              <p>مرحله اول: ارسال طراحی اولیه</p>
              <p>
                {" "}
                <MdAddCircleOutline
                  onClick={handleAddFields}
                  style={{ cursor: "pointer" }}
                />
              </p>
            </div>

            {inputFields.map((inputField, index) => (
              <div
                key={index}
                className={`d-flex justify-content-between  mt-3 ${styles.bor2}`}
              >
                <p className="mt-2 w-75 textsmall">{` نتیجه پیگیری  ${allStep[index]}`}</p>
                <div className="w-100 d-flex justify-content-end  flex-wrap">
                  <DatePicker
                    dir="ltr"
                    className={`rmdp-prime  dateBox2 my-3`}
                    style={{
                      background: "white",
                      border: "1px rgb(219, 219, 219) solid",
                      fontSize: "13px",
                      marginBottom: "10px",
                    }}
                    name="nameField"
                    placeholder="ساعت و تاریخ پیگیری"
                    format="YYYY/MM/DD HH:mm"
                    plugins={[
                      <TimePicker
                        hideSeconds
                        position="left"
                        dir="ltr"
                        style={{ direction: "ltr " }}
                      />,
                    ]}
                    calendar={persian}
                    locale={persian_fa}
                    calendarPosition="bottom-right"
                  />
                  <input
                    className={styles.inputModal3}
                    value={inputField.name}
                    onChange={(event) => handleChangeInput(index, event)}
                    name="name"
                    placeholder=" نام"
                    style={{ fontSize: "13px" }}
                  />
                  <textarea
                    className={styles.inputModal3}
                    value={inputField.name}
                    onChange={(event) => handleChangeInput(index, event)}
                    name="description"
                    placeholder="توضیحات "
                    style={{ fontSize: "13px" }}
                  />
                  {/* <div
                    className="d-flex justify-content-end w-100 align-items-center "
                    style={{
                      width: "50px",
                      fontSize: "20px",
                      color: "#333",
                      cursor: "pointer",
                    }}
                  >
                    <MdAddCircleOutline onClick={handleAddFields} />
                  </div> */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InsertAcordion;
